import moveSubOrderItem from '../../../Services/moveSubOrderItem'

export default ({ oldIndex, newIndex }) => (dispatch) => {

  if (oldIndex === newIndex) return
  
  dispatch(moveSubOrderItem(oldIndex, newIndex))

}
